
import { Error } from "@progress/kendo-react-labels";
import { TimePicker, TimePickerChangeEvent } from "@progress/kendo-react-dateinputs";

export interface TimePickerKendoRctProps{
  onChange?:(newValue: TimePickerChangeEvent) => void,
  error?:any,
  name?:string,
  title?:string,
  value?:any,
  required?:boolean,
  validityStyles?:any,
  label?:string,
  placeholder?:string,
  min?:any,
  disabled?:boolean,
  max?:any,
  steps?:any,
  show?:boolean,
  ref?:any,
  format?:string,
  fillMode?:any
  ariaDescribedBy?:any
}

function TimePickerKendoRct(props:TimePickerKendoRctProps) {

  const{
    onChange,
    error,
    name,
    title,
    value,
    required,
    validityStyles,
    label,
    placeholder,
    min,
    disabled,
    max,
    show,
    steps,
    ref,
    format,
    fillMode,
    ariaDescribedBy
  }=props

  const stepVal=steps?steps:{minute: 15}
  return (
    <div>
    
      <TimePicker
        ref={ref}
        className="icontimer"
        onChange={onChange}
        value={value}
        name={name}
        size={"medium"}
        title={title}
        required={required}
        validityStyles={validityStyles}
        min={min}
        max={max}
        label={label}
        placeholder={placeholder}
        steps={stepVal}
        disabled={disabled}
        show={show}
        format={format}
        fillMode={fillMode}
        ariaDescribedBy={ariaDescribedBy}
      />
      {error && <Error>{error}</Error>}
    </div>
  );
}
export default TimePickerKendoRct; 